import { tablesConstants } from "../_constants";

export function tablesList(state = {}, action) {
  switch (action.type) {
    case tablesConstants.GET_ALL_TABLES_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.GET_ALL_TABLES_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.GET_ALL_TABLES_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function tableById(state = {}, action) {
  switch (action.type) {
    case tablesConstants.GET_TABLE_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.GET_TABLE_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.GET_TABLE_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function tablesTopCard(state = {}, action) {
  switch (action.type) {
    case tablesConstants.GET_TOP_CARDS_TABLES_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.GET_TOP_CARDS_TABLES_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.GET_TOP_CARDS_TABLES_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function dictionaryByTableId(state = {}, action) {
  switch (action.type) {
    case tablesConstants.UPLOAD_DICTIONARY_BY_TABLE_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.UPLOAD_DICTIONARY_BY_TABLE_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.UPLOAD_DICTIONARY_BY_TABLE_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function table(state = {}, action) {
  switch (action.type) {
    case tablesConstants.ADD_TABLE_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.ADD_TABLE_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.ADD_TABLE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function tablesByConnectionId(state = {}, action) {
  switch (action.type) {
    case tablesConstants.GET_TABLES_BY_CONNECTION_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.GET_TABLES_BY_CONNECTION_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.GET_TABLES_BY_CONNECTION_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function dataDictionaryByTableId(state = {}, action) {
  switch (action.type) {
    case tablesConstants.GET_DATA_DICTIONARY_BY_TABLE_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.GET_DATA_DICTIONARY_BY_TABLE_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.GET_DATA_DICTIONARY_BY_TABLE_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function configureTable(state = {}, action) {
  switch (action.type) {
    case tablesConstants.CONFIGURE_TABLE_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.CONFIGURE_TABLE_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.CONFIGURE_TABLE_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function editTable(state = {}, action) {
  switch (action.type) {
    case tablesConstants.EDIT_TABLE_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.EDIT_TABLE_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.EDIT_TABLE_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function dataQualityEditById(state = {}, action) {
  switch (action.type) {
    case tablesConstants.EDIT_DATA_QUALITY_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.EDIT_DATA_QUALITY_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.EDIT_DATA_QUALITY_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function dataQualityByTableId(state = {}, action) {
  switch (action.type) {
    case tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.GET_DATA_QUALITY_BY_TABLE_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export  function dataQualityDeleteById(state = {}, action) {
  switch (action.type) {
    case tablesConstants.DELETE_DATA_QUALITY_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.DELETE_DATA_QUALITY_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.DELETE_DATA_QUALITY_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function addConfiguredTable(state = {}, action) {
  switch (action.type) {
    case tablesConstants.ADD_CONFIGURED_TABLE_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.ADD_CONFIGURED_TABLE_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.ADD_CONFIGURED_TABLE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function tablesFilters(state = {}, action) {
  switch (action.type) {
    case tablesConstants.GET_TABLES_FILTERS_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.GET_TABLES_FILTERS_SUCCESS:
      return {
        items: action.data,
      };
    case tablesConstants.GET_TABLES_FILTERS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function dataDictionary(state = {}, action) {
  switch (action.type) {
    case tablesConstants.GET_DATA_DICTIONARY_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.GET_DATA_DICTIONARY_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.GET_DATA_DICTIONARY_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeTable(state = {}, action) {
  switch (action.type) {
    case tablesConstants.ACTIVATE_TABLE_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.ACTIVATE_TABLE_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.ACTIVATE_TABLE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeTableByConnectionId(state = {}, action) {
  switch (action.type) {
    case tablesConstants.FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_REQUEST:
      return {
        loading: true,
      };
    case tablesConstants.FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_SUCCESS:
      return {
        item: action.data,
      };
    case tablesConstants.FETCH_ACTIVE_TABLE_BY_CONNECTION_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
